/**
 * Ask AI Service
 * Handles AI-powered track suggestion requests
 */

import { getApiClient } from '../client';
import type { Track } from '../types';

/**
 * Request to generate AI track suggestions
 */
export interface AskAIRequest {
  playlistId: string;
  position: number;
  trackCount: number;
  promptType: 'auto' | 'category' | 'playlist' | 'theme';
}

/**
 * Match statistics from Spotify search
 */
export interface MatchStats {
  requested: number;
  generated: number;
  found: number;
  ambiguous: number;
  notFound: number;
}

/**
 * Response containing AI-generated track suggestions
 */
export interface AskAIResponse {
  tracks: Track[];
  insertPosition: number;
  promptUsed: string;
  llmResponseRaw: string;
  matchStats: MatchStats;
}

export const askAIService = {
  /**
   * Generate track suggestions using AI based on playlist context
   * @param request - Configuration for AI generation
   * @returns AI-generated track suggestions with metadata
   */
  async generateTracks(request: AskAIRequest): Promise<AskAIResponse> {
    // Convert camelCase to snake_case for API
    const apiData = {
      playlist_id: request.playlistId,
      position: request.position,
      track_count: request.trackCount,
      prompt_type: request.promptType,
    };

    return getApiClient().post<AskAIResponse>('/ask-ai/generate', apiData);
  },
};
